import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { HotInsightsIcon } from "../../../assets/icons/MUI/DashboardIcons";
import { useQueryHotInsights } from "../../../api/queries/dashboard/useQueryHotInsights";
import { colors } from "../../../theme/palette";

import { InsightCard, InsightLoadingCard } from "./InsightCard";

const HotInsights = () => {
  const { t } = useTranslation();

  const { insightsList, isInsightDataLoading, isInsightDataHasError } = useQueryHotInsights();
  const isComponentLoading = isInsightDataLoading || !insightsList;

  if ((!isInsightDataLoading && insightsList?.length === 0) || !insightsList) return <></>;

  return (
    <Box sx={styles.container}>
      <Typography variant="h5Bold" sx={styles.title}>
        <HotInsightsIcon /> {t("pages.dashboard.hotInsights")}
      </Typography>
      <Box sx={styles.insightsContainer}>
        {isComponentLoading && [...Array(8)].map((_, index) => <InsightLoadingCard key={index} />)}
        {!isInsightDataLoading &&
          insightsList &&
          insightsList.length > 0 &&
          insightsList?.map((insight, index) => <InsightCard key={index} insight={insight} />)}
      </Box>
    </Box>
  );
};

export default HotInsights;

const styles = {
  container: {
    border: "1px solid #EAECF0",
    borderRadius: "8px",
    padding: "26px 18px",
    background: colors.White,
  },
  title: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    marginBottom: "20px",
  },
  insightsContainer: {
    display: "grid",
    gridTemplateColumns: {
      xs: "repeat(2, 1fr)", // 2 cards on small screens
      md: "repeat(3, 1fr)", // 3 cards on medium screens
      lg: "repeat(4, 1fr)", // 4 cards on large screens
    },
    gap: "16px",
    width: "100%",
  },
};
